/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { Button, Popconfirm } from 'antd'
import { showToast } from 'src/core/helpers'
import { useTranslation } from 'next-i18next'
import { FileSearchOutlined } from '@ant-design/icons'
import { CustomText, CustomLink } from 'src/components'
import styles from './SupppliersInfoAPIButton.module.scss'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { initSuppliersInfoAPICron, resetAdminSuppliersState, suppliersAPICronState } from 'src/features'

const SupppliersInfoAPIButton: React.FC = () => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()
  const dispatch = useAppDispatch()
  const { loading, success } = useAppSelector(suppliersAPICronState)
  const link = 'https://carboncreditquality.org/scores.html'

  useEffect(() => {
    if (success) {
      dispatch(resetAdminSuppliersState())
      showToast('success', t('admin.ProjectsEvaluated'))
    }
  }, [success])

  return (
    <div className={styles.content}>
      <Popconfirm
        disabled={loading}
        okText={t('general.Yes')}
        cancelText={t('general.Cancel')}
        title={
          <div className={styles.PopConfirm}>
            <CustomText label={t('admin.SureEvaluate')} strong/>
            <CustomText label={t('admin.EvaluateLabel')}/>
            <CustomLink label={link} link={link} isSmallText showIcon={false} />
          </div>
        }
        placement={isMobile ? 'top' : 'left'}
        cancelButtonProps={{ disabled: loading }}
        onConfirm={() => dispatch(initSuppliersInfoAPICron())}
      >
        <Button
          className={styles.button}
          block={isMobile}
          loading={loading}
          disabled={loading}
          icon={<FileSearchOutlined />}
        >
          {loading ? t('admin.EvaluatingProjects') : t('admin.EvaluateProjects')}
        </Button>
      </Popconfirm>
    </div>
  )
}

export default SupppliersInfoAPIButton
